import MaterialTable from "material-table";
import tableIcons from "../../../utils/tableIcons";
import { useEffect, useRef, useState } from "react";
import {
  // Select,
  message,
} from "antd";
import {
  GetAppointmentsBySpId,
  GetServiceProviderById,
} from "../../../utils/api";
import { useParams } from "react-router-dom";
// import Loader from "../../shared/Loader";
// import CustomSelect from "../../ui/CustomSelect";
// import SortIcon from "../../../assets/sort.svg";
import { overlayContainer } from "../../../utils/overlayContainer";
import dayjs from "dayjs";
import { convertToViewableAmount } from "../../../utils/helper";

const Bookings = () => {
  const { id } = useParams();
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 25,
    search: "",
    orderField: "",
    orderDirection: "",
    customFilter: "",
    userId: "",
  });
  const tableRef = useRef(null);

  const getServiceById = async () => {
    try {
      const res = await GetServiceProviderById(id);
      if (res?.isSuccess) {
        setQuery((prev) => ({ ...prev, userId: res?.data?.user?.id }));
      } else {
        message.error("Error while fetching details, Please try again");
      }
    } catch (error) {
      message.error("Error while fetching details, Please try again");
    }
  };

  const fetchData = async (dataquery) => {
    let params = "paymentStatus=paid&serverPaging=false";

    if (dataquery?.userId) {
      params += `&serviceProviderId=${dataquery.userId}`;
    }

    if (dataquery?.search) {
      params += `&service=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
    }

    // params += `&pageNo=${dataquery?.page + 1}`;

    // params += `&limit=${dataquery?.pageSize}`;

    if (query.customFilter) {
      params += `&statusType=${query.customFilter}`;
    }

    if (query.userId) {
      const response = await GetAppointmentsBySpId(params);
      return {
        data: response?.items,
        page: dataquery?.page,
        totalCount: response?.totalRecords,
      };
    }

    return {
      data: [],
      page: 0,
      totalCount: 0,
    };
  };

  // const handleSortChange = (option) => {
  //   setQuery((prev) => ({ ...prev, customFilter: option }));
  // };

  const columns = [
    {
      title: "Id",
      field: "uniqueId",
      sorting: true,
      cellStyle: { width: "10%" },
    },
    {
      title: "Client",
      field: "client",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return <span>{record?.client?.name}</span>;
      },
    },
    {
      title: "Date & Time",
      field: "createdAt",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return (
          <div className="flex gap-1">
            <span>{dayjs(record.date).format("DD MMM, YYYY")}</span>
            <span>{dayjs(record.startTime, "HH:mm:ss").format("h:mm A")}</span>
          </div>
        );
      },
    },
    {
      title: "Services",
      field: "service",
      sorting: false,
      cellStyle: { width: "15%" },
      render: (record) => {
        return <span>{record?.service?.serviceName}</span>;
      },
    },
    {
      title: "Status",
      field: "status",
      sorting: false,
      cellStyle: { width: "15%" },
      render: (record) => {
        return <span className="capitalize">{record?.status}</span>;
      },
    },
    {
      title: "Revenue Generated",
      field: "revenuGenerated",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return (
          <span>
            {convertToViewableAmount(
              record?.depositAmount || record?.grandTotal
            )}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    getServiceById();
    tableRef?.current?.onQueryChange(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.customFilter, query.userId]);

  return (
    <div className="w-full flex flex-col gap-y-6">
      <div className="w-full flex flex-col gap-y-4">
        <div className="search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] bg-white h-[380px] overflow-scroll flex flex-col gap-y-5 relative">
          {/* <div
            className={`custom-sortby absolute z-50 left-[284px] top-[19px] ${
              loading && "opacity-50"
            }`}
          >
            <CustomSelect
              prefixIcon={SortIcon}
              width="w-32"
              value={query.customFilter}
              onChange={(val) => handleSortChange(val)}
            >
              <Select.Option value="">All</Select.Option>
              <Select.Option value="open">Open</Select.Option>
              <Select.Option value="inProgress">In Progress</Select.Option>
              <Select.Option value="resolved">Resolved</Select.Option>
            </CustomSelect>
          </div> */}
          <MaterialTable
            title="Support Tickets"
            tableRef={tableRef}
            columns={columns}
            icons={tableIcons}
            options={{
              showTitle: false,
              draggable: false,
              sorting: true,
              paging: false,
              pageSize: 25,
              debounceInterval: 700,
              padding: "dense",
              paginationType: "stepped",
              searchFieldVariant: "outlined",
              searchFieldAlignment: "left",
            }}
            data={(query) => fetchData(query)}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h1
                    style={{
                      marginTop: "10%",
                      textAlign: "center",
                    }}
                  >
                    No records to display
                  </h1>
                ),
              },
            }}
            components={{
              OverlayLoading: (props) => {
                return <div style={overlayContainer}>{/* <Loader /> */}</div>;
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Bookings;
